import {Table} from '@tanstack/react-table';
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import {Button} from '@/shadcn_components/ui/button';
import {Input} from '@/shadcn_components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shadcn_components/ui/select';
import {useTableReturnType} from '@refinedev/core';
import SelectPerPage from './SelectPerPage';

const Pagination = ({
  table,
  tableResults,
}: {
  table: Table<any>;
  tableResults: useTableReturnType;
}) => {
  const total = tableResults.tableQuery.data?.total || 0;
  const {current, setCurrent, setPageSize} = tableResults;
  return (
    <div className="w-full flex flex-row items-center gap-2 py-2">
      <div className="flex flex-row w-min">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setCurrent(1)}
          disabled={!table.getCanPreviousPage()}>
          <ChevronDoubleLeftIcon className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setCurrent(current - 1)}
          disabled={!table.getCanPreviousPage()}>
          <ChevronLeftIcon className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setCurrent(current + 1)}
          disabled={!table.getCanNextPage()}>
          <ChevronRightIcon className="w-4 h-4" />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setCurrent(table.getPageCount())}
          disabled={!table.getCanNextPage()}>
          <ChevronDoubleRightIcon className="w-4 h-4" />
        </Button>
      </div>
      <span>Trang:</span>
      <Input
        // containerProps={{
        //   className: 'max-w-16 [&&]:h-8',
        // }}
        className="max-w-16"
        type="number"
        min={1}
        max={table.getPageCount()}
        // defaultValue={1}
        value={String(table.getState().pagination.pageIndex + 1)}
        onChange={e => {
          const page = e.target.value ? Number(e.target.value) : 0;
          setCurrent(page);
        }}
      />
      <span className="text-sm"> / {table.getPageCount()} trang.</span>
      {/* <Select
        // containerProps={{
        //   className: 'max-w-48 [&&]:h-8',
        // }}
        value={String(table.getState().pagination.pageSize)}
        onValueChange={e => {
          setPageSize(Number(e));
        }}>
        <SelectTrigger className="max-w-48">
          <SelectValue placeholder="Trang" />
        </SelectTrigger>
        <SelectContent>
          {[10, 20, 30, 40, 50].map(pageSize => (
            <SelectItem className="text-sm" key={pageSize} value={String(pageSize)}>
              {pageSize} kết quả / trang
            </SelectItem>
          ))}
        </SelectContent>
      </Select> */}
      <SelectPerPage value={table.getState().pagination.pageIndex + 1} onChange={setPageSize} />
      <span className="text-sm">Số kết quả: {total}.</span>
    </div>
  );
};

export default Pagination;
